import { cn } from "@/lib/utils";
import { Loader2, CheckCircle2, AlertTriangle, Clock, XCircle } from "lucide-react";

const config: Record<string, { label: string; icon: React.ElementType; className: string }> = {
  pending: { label: "Pending", icon: Clock, className: "bg-muted text-muted-foreground" },
  deploying: { label: "Deploying…", icon: Loader2, className: "bg-info/15 text-info" },
  live: { label: "Live", icon: CheckCircle2, className: "bg-success/15 text-success" },
  dns_issues: { label: "DNS Issues", icon: AlertTriangle, className: "bg-warning/15 text-warning" },
  error: { label: "Error", icon: XCircle, className: "bg-destructive/15 text-destructive" },
};

export default function ProvisioningBadge({ status }: { status: string }) {
  const c = config[status] || config.pending;
  const Icon = c.icon;
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium", c.className)}>
      <Icon className={cn("h-3 w-3", status === "deploying" && "animate-spin")} />
      {c.label}
    </span>
  );
}
